import React from "react";
import { Box, Text, Flex, CircularProgress, Skeleton } from "@chakra-ui/react";

export const LobbyCodeSection = ({ lobbyCode, lobbyCodeLoading, lobbyCodeError, show }) => {
  if (!show) return null;
  return (
    <Box mt={4} p={3} bg="rgba(255, 255, 255, 0.05)" borderRadius="10px">
      <Text fontSize={"12px"} color={"#D0D0D0"} fontWeight={600} mb={1}>
        Lobby Code
      </Text>
      <Box minH="28px">
        {lobbyCodeLoading ? (
          <Skeleton w="120px" h="24px" borderRadius="6px" />
        ) : lobbyCode ? (
          <Text fontSize={"18px"} fontWeight={800} color="#fff">{lobbyCode}</Text>
        ) : lobbyCodeError ? (
          <Text fontSize={"14px"} color="red.300">No lobby code available</Text>
        ) : null}
      </Box>
    </Box>
  );
}; 